import { capitalize, get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { StoreApplicant } from '@funnels/types';

import { VanillaSecondaryAction } from '../../Fields/Action';

export const ShareInformationAboutOtherApplicantsEditableView = () => null;

interface ShareInformationAboutOtherApplicantsFunnelViewProps {
  applicants: StoreApplicant[];
  targetApplicantType?: string;
}

export const ShareInformationAboutOtherApplicantsFunnelView = ({
  applicants,
  targetApplicantType = FIELD_VALUES.BORROWER,
}: ShareInformationAboutOtherApplicantsFunnelViewProps) => {
  const [formValues, setFormValue] = useFormValues();
  const placeholder = `${capitalize(targetApplicantType)}`;

  return (
    <>
      {applicants.map((applicant, index) => {
        const applicantName = applicant.firstName || `${placeholder} ${index + 1}`;

        return (
          <VanillaSecondaryAction
            key={index}
            variant={index === 0 ? 'primary' : 'secondary'}
            isFullWidth
            isSelected={index === 0}
            isDisabled={index > 0}
            className={PII_FIELD_MASKING_CLASS}
            onClick={() => {
              setFormValue(
                FIELD_PATHS.TEMP_SELECTED_APPLICANT_ID(),
                get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_ID(0))
              );
            }}
          >
            {applicantName}
          </VanillaSecondaryAction>
        );
      })}
    </>
  );
};

export const ShareInformationAboutOtherApplicantsReadOnlyView = () => null;
